import { render } from "./Philatelie.vue?vue&type=template&id=e20962b2&scoped=true&ts=true"
import script from "./Philatelie.vue?vue&type=script&lang=ts"
export * from "./Philatelie.vue?vue&type=script&lang=ts"

import "./Philatelie.vue?vue&type=style&index=0&id=e20962b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e20962b2"]])

export default __exports__